import * as Sentry from '@sentry/browser';
import { checkSentryDSN } from './utils';
import { ignoreErrors as commonIgnoreErrors } from './common';
export function init(dsn, ignoreErrors = []) {
    if (checkSentryDSN(dsn)) {
        Sentry.init({
            release: process.env.CI_COMMIT_SHA || undefined,
            dsn,
            ignoreErrors: [
                ...commonIgnoreErrors,
                'PersistedQueryNotFound',
                'PERSISTED_QUERY_NOT_FOUND',
                'NetworkError when attempting to fetch resource',
                /Loading chunk \d+ failed/,
                // Network errors
                'TypeError: NetworkError when attempting to fetch resource.',
                'TypeError: Nätverksanslutningen förlorades.',
                'TypeError: Netværksforbindelsen gik tabt.',
                'TypeError: Verkkoyhteys katkesi.',
                'Failed to fetch',
                'ResizeObserver loop',
                'Unauthorized'
            ].concat(ignoreErrors)
        });
        Sentry.configureScope((scope) => {
            scope.setTag('BUILD_TARGET', 'client');
        });
    }
}
//# sourceMappingURL=client.js.map